import { useState, useEffect } from 'react';

export function PWADebug() {
  const [debug, setDebug] = useState({
    standalone: false,
    iOS: false,
    hasPrompt: false,
    dismissed: false,
    canInstall: false,
    userAgent: '',
  });

  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                      (window.navigator as any).standalone === true;
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    
    setDebug({
      standalone,
      iOS,
      hasPrompt: false,
      dismissed: !!dismissed,
      canInstall: false,
      userAgent: navigator.userAgent,
    });

    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e: Event) => {
      // Don't prevent default in debug component to avoid conflicts
      setDebug(prev => ({ ...prev, hasPrompt: true, canInstall: true }));
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  // Only show in development
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <div className="fixed bottom-20 right-4 bg-black text-white p-4 rounded-lg text-xs max-w-xs">
      <h3 className="font-bold mb-2">PWA Debug</h3>
      <div className="space-y-1">
        <div>Standalone: {debug.standalone ? '✅' : '❌'}</div>
        <div>iOS: {debug.iOS ? '✅' : '❌'}</div>
        <div>Has Prompt: {debug.hasPrompt ? '✅' : '❌'}</div>
        <div>Dismissed: {debug.dismissed ? '✅' : '❌'}</div>
        <div>Can Install: {debug.canInstall ? '✅' : '❌'}</div>
        <div className="text-xs opacity-75 mt-2">
          UA: {debug.userAgent.substring(0, 50)}...
        </div>
      </div>
      <button
        onClick={() => {
          localStorage.removeItem('pwa-install-dismissed');
          localStorage.removeItem('pwa-install-dismissed-date');
          window.location.reload();
        }}
        className="mt-2 text-xs underline"
      >
        Reset Install Prompt
      </button>
    </div>
  );
}